import { Redirect } from 'react-router-dom';

export const ManageTradePartners = () => {
  return <Redirect to="/admin/vendor-tools/vendors" />;
};
